var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.cardData.flag)?_c('div',{staticClass:"loader"}):_c('div',{staticClass:"align-center"},[(_vm.cardData?.status)?_c('span',{staticClass:"icon-size"},[_vm._v("✅")]):_c('span',{staticClass:"icon-size"},[_vm._v("❌")]),_c('div',{staticClass:"media"},[_c('b',[_vm._v("Build Info ("+_vm._s(_vm.cardData.buildinfo)+")")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }